import React from "react";



export default function BedLinen() {
  return (
    <div className="hospitality-page">

      {/* Hero Section */}
     <div
  className="hospitality-hero"
  style={{ backgroundImage: "url(/about-hero.jpg)" }}
>
  <div className="hospitality-hero-overlay">
    <h1>Bed Linen</h1>
  </div>
</div>

      {/* Content Section */}
      <div className="hospitality-content container">
          <p>
          All custom-made styles and options are tailored from yardage within short production delays.
          Various widths available.
        </p>
        <h3>DUVET COVERS</h3>
        <ul>
          <li><strong>Material: </strong> 100% combed cotton</li>
          <li><strong>Thread Count:</strong> 100/150/200/250/300/400TC</li>
          <li><strong>Sizes: </strong> Customed Sizes</li>
          <li><strong>Design:</strong> Two embroidery lines/ Customed Sizes</li>
          <li><strong>Colors: </strong>Plain white</li>
        </ul>
        <img src="/wash_instruction.jpg" alt="Wash Instruction" />

        <h3>FLAT SHEETS: </h3>
        <ul>
          <li><strong>Material:</strong> 100% combed cotton</li>
        <li><strong>Thread Count:</strong> 100/150/200/250/300/400TC</li>
        <li><strong>Sizes:</strong> Customed Sizes</li>
        <li><strong>Design:</strong> Two embroidery lines/ Customed Sizes
                      Plain/ Stripe 0.5cm, 1cm, 2cm, 3cm, 5cm.</li>
        <li><strong>Colors:</strong> Plain white</li>
        </ul>
        <img src="/wash_instruction.jpg" alt="Wash Instruction" />

        <h3>PILLOW CASE</h3>
       <ul>
         <li><strong>Material:</strong> 100% combed cotton</li>
        <li><strong>Thread Count:</strong> 100/150/200/250/300/400TC</li>
        <li><strong>Sizes:</strong>Customed Sizes</li>
        <li><strong>Design:</strong> Two embroidery lines/ Customed Sizes Plain/ Stripe 0.5cm, 1cm, 2cm, 3cm, 5cm</li>
        <li><strong>Colors:</strong> Plain white</li>
       </ul>
       <img src="/wash_instruction.jpg" alt="Wash Instruction" />


       <h3>PILLOW</h3>
       <ul>
          <li><strong>Outer Fabric Material:</strong> 100% combed cotton</li>
          <li><strong>Thread Count:</strong> 200/250/300/400TC</li>
          <li><strong>Filling Material:</strong> 100% Microfiber, 1000g</li>
          <li><strong>Sizes:</strong> Customed Sizes</li>
          <li><strong>Design: </strong> Double stitched with self piping/ Zipper in one side
                        Plain/ Stripe 0.5cm, 1cm, 2cm, 3cm, 5cm</li>
          <li><strong>Colors:</strong> Plain white</li>
       </ul>

       <img src="/wash_instruction.jpg" alt="Wash Instruction" />


        <h3>COMFORTER</h3>
        <ul>
          <li><strong>Outer Fabric Material:</strong> 100% cotton / 50% cotton 50% polyester</li>
          <li><strong>Filling Material:</strong> 100% polyester, 280gsm</li>
          <li><strong>Design:</strong> Box quilting <br/>
              Two embroidery lines / Customed Sizes <br/>
              Plain / Stripe 0.5cm, 1cm, 2cm, 3cm, 5cm
          </li>
          <li><strong>Sizes:</strong> Customed Sizes</li>
          <li><strong>Colors:</strong> Plain white</li>
        </ul>

        <img src="/wash_instruction.jpg" alt="Wash Instruction" />

        <h3>FITTED SHEETS</h3>
      <ul>
        <li><strong>Material:</strong> 100% combed cotton</li>
        <li><strong>Thread Count:</strong> 100/150/200/250/300/400TC</li>
        <li><strong>Sizes:</strong> Customed Sizes</li>
        <li><strong>Design:</strong>
            <ul>
                <li>Two embroidery lines / Customed Sizes</li>
                <li>Plain / Stripe 0.5cm, 1cm, 2cm, 3cm, 5cm</li>
            </ul>
        </li>
        <li><strong>Colors:</strong> Plain white</li>
      </ul>

      <img src="/wash_instruction.jpg" alt="Wash Instruction" />

      <h3>MATTRESS PROTECTOR</h3>
<ul>
  <li><strong>Outer Fabric Material:</strong> 100% cotton / 50% cotton 50% polyester</li>
  <li><strong>Thread Count:</strong> 100/150/200/250/300/400TC</li>
  <li><strong>Filling Material:</strong> 100% polyester, 120gsm</li>
  <li><strong>Design:</strong>
      <ul>
          <li>Diamond check</li>
          <li>Elastic on four sides</li>
          <li>Two embroidery lines / Customed Sizes</li>
          <li>Plain / Stripe 0.5cm, 1cm, 2cm, 3cm, 5cm</li>
      </ul>
  </li>
  <li><strong>Sizes:</strong> Customed Sizes</li>
  <li><strong>Colors:</strong> Plain white</li>
</ul>

<img src="/wash_instruction.jpg" alt="Wash Instruction" />



      </div>

    </div>
  );
}
